import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import CTA from "@/components/landing/CTA";
import Assistant from "@/components/assistant/Assistant";

export default function Landing() {
  // Land at the top even when arriving from an in-app link — but never fight the
  // hash scroll in App's ScrollToTop when the link named a section ("/#pricing").
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-ink-950">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <Pricing />
        <CTA />
      </main>
      <Footer />
      {/* Public help bubble — KB-only help + contact form, no login required. */}
      <Assistant mode="public" />
    </div>
  );
}
